import React, { useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';
import { LayoutGrid, Map, History, BarChart3, User, LogOut, Truck } from 'lucide-react';
import { ThemeToggle } from '@/components/ThemeToggle';
import { useAuth } from '@/context/AuthContext';
import { Button } from '@/components/ui/button';
import { AiChatWidget } from '@/components/AiChatWidget';

const items = [
  { to: '/driver', icon: LayoutGrid, label: 'Today', end: true },
  { to: '/driver/history', icon: History, label: 'History' },
  { to: '/driver/stats', icon: BarChart3, label: 'Stats' },
  { to: '/driver/profile', icon: User, label: 'Profile' },
];

export const DriverLayout = ({ children }) => {
  const { user, logout } = useAuth();
  return (
    <div className="portal-driver min-h-screen bg-background pb-20">
      <header className="sticky top-0 z-20 bg-card/80 backdrop-blur-xl border-b border-border">
        <div className="max-w-2xl mx-auto px-4 h-14 flex items-center justify-between">
          <div className="flex items-center gap-2">
            <img src="/assets/logo.png" alt="Mobile Fuel Kart" className="h-6" />
            <span className="text-xs rounded-full px-2 py-0.5 text-white" style={{ background: 'hsl(var(--accent))' }}>Driver</span>
          </div>
          <ThemeToggle />
          <Button variant="ghost" size="icon" onClick={logout} data-testid="logout-button"><LogOut className="h-5 w-5" /></Button>
        </div>
      </header>
      <main className="max-w-2xl mx-auto px-4 py-4">{children}</main>
      <AiChatWidget mode="driver_help" />
      <nav className="fixed bottom-0 inset-x-0 z-20 bg-card border-t border-border">
        <div className="max-w-2xl mx-auto grid grid-cols-4 h-16">
          {items.map((it) => (
            <NavLink key={it.to} to={it.to} end={it.end}
              className={({ isActive }) => `flex flex-col items-center justify-center gap-1 text-xs ${isActive ? 'text-primary font-medium' : 'text-muted-foreground'}`}
              data-testid={`driver-nav-${it.label.toLowerCase()}`}>
              <it.icon className="h-5 w-5" />{it.label}
            </NavLink>
          ))}
        </div>
      </nav>
    </div>
  );
};
